import config from "../config";
import {isLoggedIn} from "./purecloud";
import { initiatePkceFlow } from "./utils";

const platformClient = window.require("platformClient");
const client = platformClient.ApiClient.instance;

//get APIs to use
const usersApi = new platformClient.UsersApi();
const notificationsApi = new platformClient.NotificationsApi();
const conversationsApi = new platformClient.ConversationsApi();
const routingApi = new platformClient.RoutingApi();

let user;

// OAuth token refresh — uses stored refresh_token if available, else full PKCE redirect
async function refreshOAuthToken() {
  console.info('Refreshing token');
  const refreshToken = sessionStorage.getItem('purecloud-refresh-token')

  if (refreshToken) {
    try {
      const params = new URLSearchParams({
        grant_type: 'refresh_token',
        refresh_token: refreshToken,
        client_id: config.purecloud.clientId
      })
      const response = await fetch(
        `https://login.${config.purecloud.name}/oauth/token`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: params.toString()
        }
      )
      if (!response.ok) throw new Error(`Refresh token exchange failed: ${response.status}`)
      const data = await response.json()
      sessionStorage.setItem('purecloud-csp-token', data.access_token)
      if (data.refresh_token) {
        sessionStorage.setItem('purecloud-refresh-token', data.refresh_token)
      }
      client.setAccessToken(data.access_token)
      console.info('Token refreshed via refresh_token')
      return data.access_token
    } catch (error) {
      console.warn('Refresh token failed, falling back to full PKCE flow:', error)
      sessionStorage.removeItem('purecloud-refresh-token')
    }
  }

  // Fall back to full PKCE authorization redirect
  await initiatePkceFlow(config.purecloud.name)
}

// Enhanced API call wrapper with 401/403 handling
async function apiCallWithRetry(apiCall) {
  try {
    return await apiCall();
  } catch (error) {
    if (error.status === 401 || error.status === 403) {
      console.info('Token expired, refreshing...');
      await refreshOAuthToken();
      return await apiCall();
    }
    throw error;
  }
}

// TM: modified to use session stored access token
async function GetAuthorization() {
  client.setEnvironment(config.purecloud.name);
  let accessToken = sessionStorage.getItem('purecloud-csp-token');

  if (!isLoggedIn()) {
    accessToken = await refreshOAuthToken();
  } else {
    client.setAccessToken(accessToken);
  }
}

// TM: Added presence definitions into user request
async function GetMe() {
  const options = {
    expand: ["presence"]
  };
  user = await apiCallWithRetry(() => usersApi.getUsersMe(options));
  return user;
}

async function GetActiveConversation() {
  const activeConversations = await apiCallWithRetry(() => conversationsApi.getConversationsCalls());
  if (activeConversations.entities.length > 0) {
    return await apiCallWithRetry(() => conversationsApi.getConversationsCall(activeConversations.entities[0].id));
  }
  return null;
}

async function GetInitialState() {
  await GetAuthorization();
  user = await GetMe();
  let activeConversation = await GetActiveConversation();

  return {
      user: user,
      activeConversation: activeConversation,
  };
}

async function GetQueue(queueId) {
  return await apiCallWithRetry(() => routingApi.getRoutingQueue(queueId));
}

async function GetChannels() {
  let opts = { includechannels: client.accessToken };

  const channels = await apiCallWithRetry(() => notificationsApi.getNotificationsChannels(opts));
  let channelId;
  if (channels.entities.length > 0) {
    channelId = channels.entities[0].id;
  } else {
    channelId = await CreateANewChannel();
  }
  console.log(channelId);
  return channelId;
}

async function CreateANewChannel() {
  const newChannel = await apiCallWithRetry(() => notificationsApi.postNotificationsChannels());
  return newChannel.id;
}

function NotificationWebSocket(sChannelId) {
  const wsUri = `wss://streaming.${config.purecloud.name}/channels/` + sChannelId;
  let websocket = new WebSocket(wsUri);
  websocket.onopen = function (evt) { onOpen(sChannelId); };
  websocket.onmessage = function (evt) { onMessage(evt); };
  websocket.onerror = function (evt) { onError(evt); };
}

async function onOpen(sChannelId) {
  let opts = {
    expand: ["expand_example"],
    includePreview: true,
  };

  const sdata = await apiCallWithRetry(() => notificationsApi.getNotificationsAvailabletopics(opts));

  let notificationId = "";
  for (var i = 0; i < sdata.entities.length; i++) {
    if (
      sdata.entities[i].id.indexOf("v2.users.{id}.conversations.calls") !== -1
    ) {
      notificationId = sdata.entities[i].id;
      break;
    }
  }
  const stindex = notificationId.indexOf("{");
  const endindex = notificationId.indexOf("}");

  notificationId = `${notificationId.slice(0, stindex)}${user.id}${notificationId.slice(endindex + 1)}`;
  await SubscribeToNotification(sChannelId, notificationId);
}

function onMessage(evt) {
  var selecteddata = JSON.parse(evt.data);
  const conv_interactionId = selecteddata.eventBody.id;

  if (selecteddata.topicName.includes("calls")) {
    if (selecteddata.eventBody !== null) {
      if (selecteddata.eventBody.participants !== null) {
        Sync_GetConversation(conv_interactionId);
      }
    }
  }
}

function onError(evt) {
  console.log(evt.data);
}

async function SubscribeToNotification(channelId, notificationId) {
  const body = [{ id: notificationId }];
  const notificationSubscription = await apiCallWithRetry(() => 
    notificationsApi.postNotificationsChannelSubscriptions(channelId, body)
  );
  console.log(`postNotificationsChannelSubscriptions success! data: ${JSON.stringify(notificationSubscription, null, 2)}`);
}

async function Sync_GetConversation(conversationId) {
  const data = await apiCallWithRetry(() => conversationsApi.getConversationsCall(conversationId));

  console.log("Sync_GetConversation", data);
  var IsCustomerConfined = false;

  if (
    data !== undefined &&
    data !== null &&
    data.participants !== undefined &&
    data.participants !== null &&
    data.participants.length > 0
  ) {
    var participants = data.participants;

    var connectedParticipants = participants.filter(function (el) {
      return (
        el.state === "connected" ||
        el.state === "dialing" ||
        el.state === "offering" ||
        el.state === "alerting"
      );
    });

    var customerDetails = participants.filter(function (el) {
      return el.purpose === "customer";
    });

    if (
      customerDetails !== undefined &&
      customerDetails !== null &&
      customerDetails.length > 0
    ) {
      IsCustomerConfined = customerDetails[0].confined;
    }

    for (var i = 0; i < participants.length; i++) {
      if (
        (participants[i].purpose === "user" ||
          participants[i].purpose === "agent") &&
        participants[i].user.id === user.id
      ) {
        if (participants[i] !== undefined && participants[i] !== null) {
          if (participants[i].state === "connected" && !participants[i].held) {
            if (connectedParticipants.length < 3) {
              if (data.recordingState !== "active") {
                // console.log("Start Rec");
                // StartStopRecording(data.id, "active");
              }
            } else {
              //Handle Consult Call
              if (!IsCustomerConfined) {
                if (data.recordingState !== "active") {
                  console.log("Start Rec");
                  StartStopRecording(data.id, "active");
                }
              } else if (data.recordingState !== "paused") {
                console.log("Stop Rec");
                document.getElementById("recordingState").innerText = "Paused";
                document.getElementById("recordingState").style.color = "red";
                StartStopRecording(data.id, "paused");
              }
            }
          } else if (participants[i].state === "connected") {
            if (data.recordingState !== "paused") {
              console.log("Stop Rec");
            }
          }
        }
      }
    }
  }
}

async function StartStopRecording(conversationId, record) {
  const body = { recordingState: record };
  
  return await apiCallWithRetry(() => conversationsApi.patchConversationsCall(conversationId, body));
}

export {
  GetAuthorization,
  GetMe,
  GetChannels,
  GetInitialState,
  NotificationWebSocket,
  notificationsApi,
  conversationsApi,
  routingApi,
  GetQueue,
  refreshOAuthToken,
  apiCallWithRetry,
};